import i18next from 'i18next';
import React from 'react';

import { Tags } from '@commons/Tags';
import Text, { ENUM_COLORS, ENUM_FONTS } from '@commons/Text';

import theme from '@src/theme';

import { ChatHeaderContainer } from './styledComponents';

const Header = (props) => {
  const { conversationName } = props;

  return (
    <ChatHeaderContainer>
      <Text color={ENUM_COLORS.BLACK} font={ENUM_FONTS.H2_INTER}>
        {conversationName}
      </Text>
      <Tags
        items={[i18next.t('GENERAL.BETA')]}
        labelCustomStyle={{
          backgroundColor: theme.colors.brand.primary,
          color: theme.colors.black,
        }}
        onlyLabel
      />
    </ChatHeaderContainer>
  );
};

export default Header;
